import { cn } from "@/lib/utils";

const heroToneClasses = {
  slate: "border-slate-200/80 bg-gradient-to-r from-white via-slate-50 to-slate-100/90",
  emerald: "border-emerald-200/80 bg-gradient-to-r from-emerald-50 via-teal-50 to-white",
  amber: "border-amber-200/80 bg-gradient-to-r from-amber-50 via-orange-50 to-white",
  sky: "border-sky-200/80 bg-gradient-to-r from-sky-50 via-cyan-50 to-white",
  violet: "border-violet-200/80 bg-gradient-to-r from-violet-50 via-fuchsia-50 to-white",
};

const heroEyebrowClasses = {
  slate: "bg-slate-100 text-slate-700",
  emerald: "bg-emerald-100 text-emerald-700",
  amber: "bg-amber-100 text-amber-700",
  sky: "bg-sky-100 text-sky-700",
  violet: "bg-violet-100 text-violet-700",
};

export const PageShell = ({ className, children, ...props }) => {
  return (
    <div
      className={cn("mx-auto flex w-full max-w-7xl flex-col gap-6", className)}
      {...props}
    >
      {children}
    </div>
  );
};

export const PageHeader = ({
  title,
  description,
  actions,
  eyebrow,
  className,
  titleClassName,
  descriptionClassName,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 md:flex-row md:items-start md:justify-between",
        className
      )}
    >
      <div className="max-w-3xl space-y-3">
        {eyebrow ? (
          <p className="inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-xs font-manrope font-semibold text-primary">
            {eyebrow}
          </p>
        ) : null}
        <div className="space-y-1.5">
          <h1
            className={cn(
              "font-manrope text-3xl font-extrabold tracking-tight text-slate-900 md:text-4xl",
              titleClassName
            )}
          >
            {title}
          </h1>
          {description ? (
            <p className={cn("max-w-2xl text-sm text-muted-foreground md:text-base", descriptionClassName)}>
              {description}
            </p>
          ) : null}
        </div>
      </div>
      {actions ? <div className="flex flex-wrap gap-2 md:justify-end">{actions}</div> : null}
    </div>
  );
};

export const PageHero = ({
  title,
  description,
  actions,
  eyebrow,
  tone = "slate",
  className,
  titleClassName,
}) => {
  return (
    <section
      className={cn(
        "rounded-3xl border p-6 shadow-sm md:p-7",
        heroToneClasses[tone] || heroToneClasses.slate,
        className
      )}
    >
      <div className="flex flex-col gap-5 md:flex-row md:items-start md:justify-between">
        <div className="max-w-3xl space-y-3">
          {eyebrow ? (
            <p
              className={cn(
                "inline-flex items-center rounded-full px-3 py-1 text-xs font-manrope font-semibold",
                heroEyebrowClasses[tone] || heroEyebrowClasses.slate
              )}
            >
              {eyebrow}
            </p>
          ) : null}
          <div className="space-y-1.5">
            <h1
              className={cn(
                "font-manrope text-3xl font-extrabold tracking-tight text-slate-900 md:text-4xl",
                titleClassName
              )}
            >
              {title}
            </h1>
            {description ? (
              <p className="max-w-2xl text-sm text-muted-foreground md:text-base">
                {description}
              </p>
            ) : null}
          </div>
        </div>
        {actions ? <div className="flex flex-wrap gap-2 md:justify-end">{actions}</div> : null}
      </div>
    </section>
  );
};
